import RightContent from "../../components/OnBoard/RightContent";
import Menu from "../../components/OnBoard/Menu";
import styles from "./UserOnboarding2.module.css";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import UserOnboardingSteps from "../../components/OnBoard/UserOnboardingSteps";

const UserOnboarding3 = () => {
  const userData = JSON.parse(localStorage.getItem("user_data"))
  const User=useSelector(state=>state.User)
  const navigate = useNavigate();
  const handleNavigate=()=>{
    
    localStorage.clear()
    if(User.user_type=="Super Admin" || User.user_type=="internal_user"){
      navigate("/users")
    }
    else{
      navigate("/login")

    }
  }
  return (
    <div className={styles.userOnboarding}>
      <RightContent step={4} />
      <section className={styles.leftContent}>
        <div className={styles.progressForm}>
          <div className={userData.user_type="Verifier"?styles.VerifierProgress:styles.progressForm1}>
            {/* <Menu pos="4" USER={userData.IsVerifier}/> */}
            <UserOnboardingSteps stepNo={3}/>

            <div className={styles.form}>
              <div className={styles.form1}>
                <div className={styles.iconHeading}>
                  <img
                    className={styles.checkCircleIcon}
                    alt=""
                    src="/checkcircle.svg"
                  />
                  <div className={styles.headingHelperText}>
                    <h3 className={styles.heading}>Verified</h3>
                    </div>
                        
                </div>
                <div className={styles.supportingText}>
                      You have successfully verified your account.
                    </div>
                <div className={styles.buttonHelperText} style={{padding:"0rem", marginTop:"1rem"}}>
                  <button className="primaryBtn" onClick={()=> handleNavigate()}>
                      Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.buttonHelperText1} />
      </section>
    </div>
  );
};

export default UserOnboarding3;
